export default __webpack_public_path__ + "low-pressure-icon.png";